import { Controller, useController, useWatch } from 'react-hook-form';

import Checkbox from '../../../../../../components/Checkbox/Checkbox';
import { RULES, SUB_TOPIC_ID, TOPIC } from '../../../../../../constants/formFields';

import type IStandardTopicsItem from '../../../../../../store/slices/survey/interfaces/IStandardTopicsItem';
import type { ISurveyAnswerPrioritiseTopicProps } from '../interfaces/ISurveyAnswerPrioritiseTopic';

import styles from './scss/SubTopicCheckboxList.module.scss';

function PrioritiseSubTopicCheckboxList({
  control,
  standardTopicsData,
}: ISurveyAnswerPrioritiseTopicProps) {
  const selectedTopicIds = useWatch({
    control,
    name: TOPIC,
    defaultValue: [],
  });

  const filteredTopicsData = standardTopicsData
    .filter((topic: IStandardTopicsItem) => Array.isArray(selectedTopicIds) && selectedTopicIds.includes(topic.id));

  const {
    field: {
      value: rulesValue,
      onChange: onRulesChange,
    },
  } = useController({
    name: RULES,
    control,
    defaultValue: [],
  });

  return (
    <div className={styles.container}>
      <Controller
        control={control}
        name={SUB_TOPIC_ID}
        defaultValue={[]}
        render={({ field: { value = [], onChange } }) => (
          <>
            {filteredTopicsData.map((topic: IStandardTopicsItem) => (
              <div key={topic.id} className={styles.topicGroup}>
                <div className={styles.groupTitle}>
                  <span>{topic.standard.name}</span>
                  {' '}
                  Topic -
                  {' '}
                  <span>{topic.title}</span>
                </div>
                <div className={styles.subTopicsContainer}>
                  {topic.children.map((subTopic) => (
                    <div key={subTopic.id} className={styles.subTopic}>
                      <Checkbox
                        name={`subtopic-${subTopic.id}`}
                        value={subTopic.id.toString()}
                        checked={Array.isArray(value) && value.some((item) => item.subTopicId === subTopic.id)}
                        label={subTopic.title}
                        onChange={(event) => {
                          const { checked } = event.target;
                          const currentValue = Array.isArray(value) ? value : [];
                          const currentRules = Array.isArray(rulesValue) ? rulesValue : [];

                          if (checked) {
                            if (!currentValue.some((item) => item.subTopicId === subTopic.id)) {
                              const newRule = {
                                subTopicId: subTopic.id,
                                topicId: topic.id,
                                position: currentRules.length + 1,
                              };

                              onChange([
                                ...currentValue,
                                { subTopicId: subTopic.id, topicId: topic.id },
                              ]);
                              onRulesChange([...currentRules, newRule]);
                            }
                          } else {
                            const updatedSubTopics = currentValue.filter((item) => item.subTopicId !== subTopic.id);
                            const updatedRules = currentRules
                              .filter((rule) => rule.subTopicId !== subTopic.id)
                              .map((rule, index) => ({
                                ...rule,
                                position: index + 1,
                              }));

                            onChange(updatedSubTopics);
                            onRulesChange(updatedRules);
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}
      />
    </div>
  );
}

export default PrioritiseSubTopicCheckboxList;
